import React from 'react'

interface Project {
  id: string
  projectName: string
  clientId: string
  urlStatus: string
  url: string
  websiteUrl: string
  startDate: string
  client: string
  pmPl: any[]
  industry: string
  service: Array<{id: number; vName: string}>
  technology: Array<{id: number; vName: string}>
  framework: Array<{id: number; vName: string}>
  eNDAprotected: string
  dHealthCheckedDate: string
  responseTime: string
  portfolio: any
  vWhatWeDid?: string
  vPortfolioChallenges?: string
  vHowWeSolved?: string
  vTechStackUsed?: string
  [key: string]: any
}

interface PortfolioDisplayProps {
  projects: Project[]
  showButtons?: boolean
  onGenerateLink?: () => void
  isExportLoading?: boolean
  downloadLink?: string
  onCopyLink?: () => void
  onEditProject?: (projectId: string) => void
}

const PortfolioDisplay: React.FC<PortfolioDisplayProps> = ({
  projects,
  showButtons = true,
  onGenerateLink,
  isExportLoading = false,
  downloadLink = '',
  onCopyLink,
  onEditProject,
}) => {
  const handleCopyLink = () => {
    if (downloadLink && onCopyLink) {
      onCopyLink()
    }
  }

  console.log('projects', projects)

  return (
    <div
      className='portfolio-container'
      style={{
        fontFamily: 'Helvetica, Arial, sans-serif',
        margin: 'auto',
        padding: '20px',
        backgroundColor: '#f5f5f5',
        color: '#333333',
        minHeight: '100vh',
        width: '50vw',
        justifyContent: 'center',
      }}
    >
      {/* Header */}
      <div
        style={{
          backgroundColor: '#0A2B3D',
          color: 'aliceblue',
          padding: '20px',
          textAlign: 'center',
          marginBottom: '10px',
          borderRadius: '8px',
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: '18px',
            fontWeight: 'bold',
            color: 'aliceblue',
            textShadow: '0px 1px 2px rgba(0,0,0,0.5)',
          }}
        >
          Project Portfolio
        </h1>
      </div>

      {/* Action buttons - only show if showButtons is true */}
      {showButtons && (
        <>
          <div
            style={{
              display: 'flex',
              gap: '12px',
              marginBottom: '10px',
              justifyContent: 'flex-start',
            }}
          >
            {onGenerateLink && !downloadLink && (
              <button
                type='button'
                style={{
                  backgroundColor: isExportLoading ? '#6c757d' : '#0A2B3D',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '8px 16px',
                  fontSize: '12px',
                  cursor: isExportLoading ? 'not-allowed' : 'pointer',
                  opacity: isExportLoading ? 0.7 : 1,
                  width: 'auto',
                  whiteSpace: 'nowrap',
                }}
                onClick={onGenerateLink}
                disabled={isExportLoading}
              >
                {isExportLoading ? (
                  <>
                    <span
                      style={{
                        display: 'inline-block',
                        width: '10px',
                        height: '10px',
                        border: '2px solid #fff',
                        borderBottomColor: 'transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        marginRight: '8px',
                      }}
                    />
                    Generating...
                  </>
                ) : (
                  'Generate Link'
                )}
              </button>
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              {downloadLink && onCopyLink && (
                <button
                  type='button'
                  style={{
                    backgroundColor: '#0A2B3D',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '8px 16px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    opacity: 1,
                    width: 'auto',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={handleCopyLink}
                >
                  Copy Portfolio Link
                </button>
              )}

              {showButtons && downloadLink && (
                <div
                  style={{
                    textAlign: 'right',
                    fontSize: '12px',
                    color: '#0A2B3D',
                    right: '0',
                    position: 'relative',
                  }}
                  className='alert-warning'
                >
                  ⚠️ This link will remain valid for 30 days from the date of generation.
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* Projects Container */}
      <div>
        {projects.map((project) => (
          <div
            key={project.id}
            className='project-card print-page-break'
            data-project-id={project.id}
            style={{
              background: 'white',
              border: '1px solid #d9dce5',
              borderRadius: '8px',
              marginBottom: '20px',
              overflow: 'hidden',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              position: 'relative',
            }}
          >
            {/* Edit Project Button - only show if showButtons is true */}
            {showButtons && onEditProject && (
              <button
                type='button'
                className='edit-project-btn'
                onClick={() => onEditProject(project.id)}
                style={{
                  position: 'absolute',
                  right: '15px',
                  top: '15px',
                  background: '#0A2B3D',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '4px 8px',
                  fontSize: '10px',
                  cursor: 'pointer',
                  zIndex: 10,
                }}
              >
                Edit
              </button>
            )}

            {/* Project Header */}
            <div
              style={{
                backgroundColor: '#f6f7f8',
                padding: '15px 20px',
                borderBottom: '1px solid #d9dce5',
              }}
            >
              <div
                style={{
                  fontSize: '13px',
                  fontWeight: 'bold',
                  color: '#0A2B3D',
                  margin: 0,
                }}
              >
                {project.projectName}
              </div>
            </div>

            {/* Project Content */}
            <div style={{padding: '15px 20px'}}>
              <div
                style={{
                  display: 'flex',
                  marginBottom: '10px',
                  gap: '20px',
                }}
              >
                <div style={{flex: 1}}>
                  <div
                    style={{
                      fontSize: '9px',
                      fontWeight: 'bold',
                      color: '#333333',
                      marginBottom: '2px',
                    }}
                  >
                    Website:
                  </div>
                  <div
                    style={{
                      fontSize: '9px',
                      color: '#333333',
                      lineHeight: '1.4',
                    }}
                  >
                    {project.url || '-'}
                  </div>
                </div>
                <div style={{flex: 1}}>
                  <div
                    style={{
                      fontSize: '9px',
                      fontWeight: 'bold',
                      color: '#333333',
                      marginBottom: '2px',
                    }}
                  >
                    Client:
                  </div>
                  <div
                    style={{
                      fontSize: '9px',
                      color: '#333333',
                      lineHeight: '1.4',
                    }}
                  >
                    {project.client || '-'}
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  marginBottom: '10px',
                  gap: '20px',
                }}
              >
                <div style={{flex: 1}}>
                  <div
                    style={{
                      fontSize: '9px',
                      fontWeight: 'bold',
                      color: '#333333',
                      marginBottom: '2px',
                    }}
                  >
                    Industry:
                  </div>
                  <div
                    style={{
                      fontSize: '9px',
                      color: '#333333',
                      lineHeight: '1.4',
                    }}
                  >
                    {project.industry || '-'}
                  </div>
                </div>
                <div style={{flex: 1}}>
                  <div
                    style={{
                      fontSize: '9px',
                      fontWeight: 'bold',
                      color: '#333333',
                      marginBottom: '2px',
                    }}
                  >
                    Technology:
                  </div>
                  <div
                    style={{
                      fontSize: '9px',
                      color: '#333333',
                      lineHeight: '1.4',
                    }}
                  >
                    {project.technology?.map((tech, index) => (
                      <span key={index}>
                        {tech.vName}
                        {index < project.technology.length - 1 && ', '}
                      </span>
                    )) || '-'}
                  </div>
                </div>
              </div>

              {/* Case Study Section */}
              {(project.portfolio?.vWhatWeDid ||
                project.portfolio?.vPortfolioChallenges ||
                project.portfolio?.vHowWeSolved ||
                project.portfolio?.vTechStackUsed) && (
                <div
                  className='print-section-break'
                  style={{
                    marginTop: '20px',
                    paddingTop: '20px',
                    borderTop: '1px solid #e5e5e5',
                  }}
                >
                  <div
                    style={{
                      fontSize: '11px',
                      fontWeight: 'bold',
                      color: '#0A2B3D',
                      marginBottom: '15px',
                    }}
                  >
                    Case Study
                  </div>

                  {project.portfolio?.vWhatWeDid && (
                    <div style={{marginBottom: '12px'}}>
                      <div
                        style={{
                          fontSize: '10px',
                          fontWeight: 'bold',
                          color: '#333333',
                          marginBottom: '4px',
                        }}
                      >
                        What we did for this client?
                      </div>
                      <div
                        className='rich-text-content'
                        style={{
                          fontSize: '9px',
                          color: '#333333',
                          lineHeight: '1.4',
                        }}
                        dangerouslySetInnerHTML={{__html: project.portfolio?.vWhatWeDid || ''}}
                      />
                    </div>
                  )}

                  {project.portfolio?.vPortfolioChallenges && (
                    <div style={{marginBottom: '12px'}}>
                      <div
                        style={{
                          fontSize: '10px',
                          fontWeight: 'bold',
                          color: '#333333',
                          marginBottom: '4px',
                        }}
                      >
                        Challenges faced
                      </div>
                      <div
                        className='rich-text-content'
                        style={{
                          fontSize: '9px',
                          color: '#333333',
                          lineHeight: '1.4',
                        }}
                        dangerouslySetInnerHTML={{__html: project.portfolio?.vPortfolioChallenges}}
                      />
                    </div>
                  )}

                  {project.portfolio?.vHowWeSolved && (
                    <div style={{marginBottom: '12px'}}>
                      <div
                        style={{
                          fontSize: '10px',
                          fontWeight: 'bold',
                          color: '#333333',
                          marginBottom: '4px',
                        }}
                      >
                        How we solved the challenges?
                      </div>
                      <div
                        className='rich-text-content'
                        style={{
                          fontSize: '9px',
                          color: '#333333',
                          lineHeight: '1.4',
                        }}
                        dangerouslySetInnerHTML={{__html: project.portfolio?.vHowWeSolved}}
                      />
                    </div>
                  )}

                  {project.portfolio?.vTechStackUsed && (
                    <div style={{marginBottom: '12px'}}>
                      <div
                        style={{
                          fontSize: '10px',
                          fontWeight: 'bold',
                          color: '#333333',
                          marginBottom: '4px',
                        }}
                      >
                        Technology stack used
                      </div>
                      <div
                        className='rich-text-content'
                        style={{
                          fontSize: '9px',
                          color: '#333333',
                          lineHeight: '1.4',
                        }}
                        dangerouslySetInnerHTML={{__html: project.portfolio?.vTechStackUsed || ''}}
                      />
                    </div>
                  )}
                </div>
              )}

              {/* Website Preview Section */}
              {project.portfolio?.autoCapturedWebsiteImageUrl && (
                <div
                  className='print-section-break'
                  style={{
                    marginTop: '20px',
                    paddingTop: '20px',
                    borderTop: '1px solid #e5e5e5',
                  }}
                >
                  <div
                    style={{
                      fontSize: '11px',
                      fontWeight: 'bold',
                      color: '#0A2B3D',
                      marginBottom: '15px',
                    }}
                  >
                    Website Preview
                  </div>
                  <div style={{marginBottom: '15px'}}>
                    <img
                      src={project.portfolio.autoCapturedWebsiteImageUrl}
                      alt={`${project.projectName} website preview`}
                      style={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: '6px',
                        border: '1px solid #d9dce5',
                      }}
                    />
                  </div>
                </div>
              )}

              {/* Other Images Section */}
              {project.portfolio?.websiteImageUrls &&
                project.portfolio.websiteImageUrls.length > 0 && (
                  <div
                    className='print-section-break'
                    style={{
                      marginTop: '20px',
                      paddingTop: '20px',
                      borderTop: '1px solid #e5e5e5',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '11px',
                        fontWeight: 'bold',
                        color: '#0A2B3D',
                        marginBottom: '15px',
                      }}
                    >
                      Other Images
                    </div>
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '10px',
                        marginBottom: '15px',
                      }}
                    >
                      {project.portfolio.websiteImageUrls.map((imageUrl, index) => (
                        <img
                          key={index}
                          src={imageUrl}
                          alt={`${project.projectName} ${index + 1}`}
                          style={{
                            width: '100%',
                            height: '150px',
                            objectFit: 'cover',
                            borderRadius: '4px',
                            border: '1px solid #d9dce5',
                            cursor: 'pointer',
                          }}
                          onClick={() => window.open(imageUrl, '_blank')}
                        />
                      ))}
                    </div>
                  </div>
                )}
            </div>
          </div>
        ))}
      </div>

      {/* Add keyframes for spinner animation */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @media print {
          body { 
            padding: 0 !important; 
            margin: 0 !important;
          }
          
          /* Full width for printing */
          .portfolio-container {
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
            padding: 10px !important;
          }
          
          /* Project card page breaks */
          .print-page-break {
            page-break-inside: avoid !important;
            page-break-after: always !important;
            border: 1px solid #ccc !important;
            margin-bottom: 10px !important;
          }
          
          /* Remove page break from last project card */
          .print-page-break:last-child {
            page-break-after: auto !important;
          }
          
          /* Section page breaks */
          .print-section-break {
            page-break-before: always !important;
            border-top: none !important;
            margin-top: 10px !important;
            padding-top: 10px !important;
          }
          
          /* Ensure proper text visibility */
          .portfolio-container,
          .portfolio-container * {
            color: #000000 !important;
            text-shadow: none !important;
          }
          
          /* Header specific */
          .portfolio-container h1 {
            color: #000000 !important;
            text-shadow: none !important;
          }
          
          /* Remove buttons from print */
          button {
            display: none !important;
          }
          
          /* Ensure images print properly */
          img {
            max-width: 100% !important;
            height: auto !important;
            page-break-inside: avoid !important;
            border: none !important;
          }
          
          /* Remove backgrounds for cleaner print */
          div {
            background-color: transparent !important;
            background: transparent !important;
          }
          
          /* Ensure text is visible */
          .portfolio-container div {
            color: #000000 !important;
          }
        }
      `}</style>
    </div>
  )
}

export default PortfolioDisplay
